// The gallery uses the browser clock directly. A runtime supplies a pauseable clock for
// both action frames and drawing, so pausing never lets an action run ahead.
let driver = null;
export const clockNow = () => driver ? driver.now() : performance.now();
export const frame = cb => driver ? driver.frame(cb) : requestAnimationFrame(cb);
export const later = (cb, ms) => driver ? driver.later(cb, ms) : setTimeout(cb, ms);
export function useClock(clock) { driver = clock; }
